// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WysiwygButton--floatLeft,.WysiwygButton--floatRight{margin:1rem 0;margin:.25rem 0}.WysiwygButton--floatLeft{float:left;margin-right:1rem}.WysiwygButton--floatRight{float:right;margin-left:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
